import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  logo: {
    height: 28,
    width: 'auto',
    maxWidth: '100%',
    objectFit: 'contain',
  },
});

export const LogoIcon = () => {
  const classes = useStyles();
  return <img src="/ahead-logo.png" alt="AHEAD" className={classes.logo} />;
};
